import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ikhlasLogo from "/svg/ikhlas-logo.svg";

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isToursDropdownOpen, setIsToursDropdownOpen] = useState(false);
  const [isVehiclesDropdownOpen, setIsVehiclesDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleWhatsAppClick = () => {
    window.open(
      "https://wa.me/64221841601?text=Hi! I'm interested in learning more about your tours.",
      "_blank",
    );
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="shrink-0">
            <Link to="/" className="flex items-center">
              <img
                src={ikhlasLogo}
                alt="Ikhlas Tours"
                className="w-[90px] lg:w-[110px] overflow-hidden"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={` hover:text-primary transition-colors ${
                location.pathname === "/"
                  ? "text-primary font-semibold"
                  : "text-primaryText"
              }`}
            >
              Home
            </Link>

            {/* Tours Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setIsToursDropdownOpen(true)}
              onMouseLeave={() => setIsToursDropdownOpen(false)}
            >
              <Link
                to="/tours"
                className={`cursor-pointer hover:text-primary transition-colors flex items-center space-x-1 ${
                  location.pathname.includes("/tours")
                    ? "text-primary font-semibold"
                    : "text-primaryText"
                }`}
              >
                <span>Tours</span>
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </Link>

              {isToursDropdownOpen && (
                <div className="absolute top-full left-0 mt-0 w-48 bg-white rounded-md shadow-lg py-1">
                  <Link
                    to="/tours/north-island"
                    className="block px-4 py-2 text-primaryText hover:bg-primary hover:text-white transition-colors"
                  >
                    North Island
                  </Link>
                  <Link
                    to="/tours/south-island"
                    className="block px-4 py-2 text-primaryText hover:bg-primary hover:text-white transition-colors"
                  >
                    South Island
                  </Link>
                  <Link
                    to="/tours/combo-island"
                    className="block px-4 py-2 text-primaryText hover:bg-primary hover:text-white transition-colors"
                  >
                    Combo Island
                  </Link>
                </div>
              )}
            </div>

            {/* Vehicles Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setIsVehiclesDropdownOpen(true)}
              onMouseLeave={() => setIsVehiclesDropdownOpen(false)}
            >
              <Link
                to="/vehicles"
                className={`cursor-pointer hover:text-primary transition-colors flex items-center space-x-1 ${
                  location.pathname.includes("/vehicles")
                    ? "text-primary font-semibold"
                    : "text-primaryText"
                }`}
              >
                <span>Vehicles</span>
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </Link>

              {isVehiclesDropdownOpen && (
                <div className="absolute top-full left-0 mt-0 w-48 bg-white rounded-md shadow-lg py-1">
                  <Link
                    to="/vehicles/cars"
                    className="block px-4 py-2 text-primaryText hover:bg-primary hover:text-white transition-colors"
                  >
                    Cars
                  </Link>
                  <Link
                    to="/vehicles/motorhomes"
                    className="block px-4 py-2 text-primaryText hover:bg-primary hover:text-white transition-colors"
                  >
                    Motorhomes
                  </Link>
                </div>
              )}
            </div>
            <Link
              to="/activities"
              className={` hover:text-primary transition-colors ${
                location.pathname === "/activities"
                  ? "text-primary font-semibold"
                  : "text-primaryText"
              }`}
            >
              Activities
            </Link>
            <Link
              to="/contact"
              className={` hover:text-primary transition-colors ${
                location.pathname === "/contact"
                  ? "text-primary font-semibold"
                  : "text-primaryText"
              }`}
            >
              Contact
            </Link>
            <Link
              to="/about"
              className={`${
                location.pathname === "/about"
                  ? "text-primary font-semibold"
                  : "text-primaryText"
              } hover:text-primary transition-colors`}
            >
              About
            </Link>
            {/* <Link
              to="/faq"
              className={`hover:text-primary transition-colors ${
                location.pathname === "/faq"
                  ? "text-primary font-semibold"
                  : "text-primaryText"
              }`}
            >
              FAQ
            </Link> */}

            {/* WhatsApp Button */}
            <button
              onClick={handleWhatsAppClick}
              className="bg-whatsapp cursor-pointer text-white px-4 py-2 rounded-md hover:bg-green-600 transition-colors flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.123-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
              <span>WhatsApp</span>
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-primaryText hover:text-primary focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Tray */}
        {isMobileMenuOpen && (
          <div className="lg:hidden fixed inset-x-0 top-16 z-50 bg-white shadow-2xl">
            {/* Navigation Links */}
            <div className="overflow-y-auto p-4 space-y-1">
              <Link
                to="/"
                className="block px-3 py-2 text-primaryText hover:text-primary transition-colors"
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
              <div className="px-3 py-2">
                <Link
                  to="/tours"
                  className="text-primaryText"
                  onClick={toggleMobileMenu}
                >
                  Tours
                </Link>
                <div className="pl-4 mt-1 space-y-1">
                  <Link
                    to="/tours/north-island"
                    className="block py-1 text-sm text-primaryText hover:text-primary transition-colors"
                    onClick={toggleMobileMenu}
                  >
                    North Island
                  </Link>
                  <Link
                    to="/tours/south-island"
                    className="block py-1 text-sm text-primaryText hover:text-primary transition-colors"
                    onClick={toggleMobileMenu}
                  >
                    South Island
                  </Link>
                  <Link
                    to="/tours/combo-island"
                    className="block py-1 text-sm text-primaryText hover:text-primary transition-colors"
                    onClick={toggleMobileMenu}
                  >
                    Combo Island
                  </Link>
                </div>
              </div>

              <div className="px-3 py-2">
                <Link
                  to="/vehicles"
                  className="text-primaryText"
                  onClick={toggleMobileMenu}
                >
                  Vehicles
                </Link>
                <div className="pl-4 mt-1 space-y-1">
                  <Link
                    to="/vehicles/cars"
                    className="block py-1 text-sm text-primaryText hover:text-primary transition-colors"
                    onClick={toggleMobileMenu}
                  >
                    Cars
                  </Link>
                  <Link
                    to="/vehicles/motorhomes"
                    className="block py-1 text-sm text-primaryText hover:text-primary transition-colors"
                    onClick={toggleMobileMenu}
                  >
                    Motorhomes
                  </Link>
                </div>
              </div>
              <Link
                to="/activities"
                className="block px-3 py-2 text-primaryText hover:text-primary transition-colors"
                onClick={toggleMobileMenu}
              >
                Activities
              </Link>
              <Link
                to="/contact"
                className="block px-3 py-2 text-primaryText hover:text-primary transition-colors"
                onClick={toggleMobileMenu}
              >
                Contact
              </Link>
              <Link
                to="/about"
                className="block px-3 py-2 text-primaryText hover:text-primary transition-colors"
                onClick={toggleMobileMenu}
              >
                About
              </Link>
              <Link
                to="/faq"
                className="block px-3 py-2 text-primaryText hover:text-primary transition-colors"
                onClick={toggleMobileMenu}
              >
                FAQ
              </Link>
              <button
                onClick={handleWhatsAppClick}
                className="w-full text-left px-3 py-2 bg-whatsapp cursor-pointer text-white rounded-md hover:bg-green-600 transition-colors flex items-center space-x-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.123-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                <span>WhatsApp</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
